import React, {useEffect} from 'react'
import {getPageTitle} from '../../utils/utils'

const PageTitle = props => {
    useEffect(() => {
        document.title = getPageTitle(props.location.pathname)
    }, [props.location.pathname])

    const PageComponent = props.component
    return <PageComponent />
}

export default PageTitle
